import Swiper from 'swiper';

export default new class TripleSlider {
    constructor() {
        this.sliderContainerSelector = 'js-triple-slider';
        this.navigation = {
            nextEl: '.triple-button-next',
            prevEl: '.triple-button-prev',
            disabledClass: 'trustpilot-button-disabled'
        };
        this.handler();
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`);

        if (!slider) return;

        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        const { navigation } = this;
        this.TripleSlider = new Swiper(`.${this.sliderContainerSelector}`, {
            navigation,
            slidesPerView: 1,
            initialSlide: 1,
            spaceBetween: 16,
            loop: false,
            observer: true,
            autoHeight: true,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
    }
}();
